import request from '@/utils/request'; //登录sdk配置 新增配置

export function restKeyId(data) {
  return request({
    url: '/pay/reload_login_sdk',
    method: 'get',
    params: data
  });
}